// extracted by mini-css-extract-plugin
export default {"divider":"DividerHorizonal_divider__pUbES"};